import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { endPoints } from "../../constants/endPoints";
import { ISearchQueryParams } from "../common/common.types";
import { addSearchFilterToAdvanceFilter } from "../common/helpers";
import { upsertItemInList } from "../common/upsertInList";
import { IStoreState } from "../initialStoreState";
import {
  closeLoaderWithMessage,
  openLoaderWithMessage,
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { ICrossroadsLead, IFollowUpHistory } from "./CrossroadsLeads.types";

/** Re-export for components: dispatch(upsertItemInList("crossroadsLeads", lead)) for local-only list updates. */
export { upsertItemInList } from "../common/upsertInList";

/* =========================================================
   LIST ACTIONS
========================================================= */
export const FETCH_CROSSROADS_LEADS_LIST_PROGRESS = "FETCH_CROSSROADS_LEADS_LIST_PROGRESS";
export const FETCH_CROSSROADS_LEADS_LIST_SUCCESS = "FETCH_CROSSROADS_LEADS_LIST_SUCCESS";
export const FETCH_CROSSROADS_LEADS_LIST_FAILURE = "FETCH_CROSSROADS_LEADS_LIST_FAILURE";

export const fectchCrossroadsLeadsListProgress = () => action(FETCH_CROSSROADS_LEADS_LIST_PROGRESS);
export const fectchCrossroadsLeadsListSuccess = (list: ICrossroadsLead[], totalRecords: number) =>
  action(FETCH_CROSSROADS_LEADS_LIST_SUCCESS, { list, totalRecords });
export const fectchCrossroadsLeadsListFailure = () => action(FETCH_CROSSROADS_LEADS_LIST_FAILURE);

export const fectchCrossroadsLeadsListAsync = (queryParams: ISearchQueryParams): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      // dispatch(fectchCrossroadsLeadsListProgress());
      // const url = getSearchQueryV2(queryParams);
      // const res = await api.get(`${endPoints.crossroadsLeads.getCrossroadsLeadsList}?${url}`);
      // const data: ICrossroadsLead[] = res.data?.data || [];
      // const totalRecords = res.data?.totalRecords || 0;
      // dispatch(fectchCrossroadsLeadsListSuccess(data, totalRecords));

      dispatch(fectchCrossroadsLeadsListProgress());


      const {
        page, rowsPerPage, limit, status,
        membership,
        user_name,
        contact_number,
        email_id,
        campaign_name,
        city,
        pin_code,
        package_name,
        disposition,
        primary_disposition,
        follow_up_date,
        advancedFilters,
        date
      } = queryParams as any;


      // const advanceFilter: any[] = [];

      // here the advanceFilter is an array, cloning the existing filter or defaulting to empty
      //and adding the filters already present using (spread operator).
      const advanceFilter: any[] = Array.isArray(advancedFilters) ? [...advancedFilters] : [];

      addSearchFilterToAdvanceFilter(advanceFilter, ["user_name"], user_name);
      addSearchFilterToAdvanceFilter(advanceFilter, ["contact_number"], contact_number);
      //addSearchFilterToAdvanceFilter(advanceFilter, ["email_id"], email_id);
      addSearchFilterToAdvanceFilter(advanceFilter, ["campaign_name"], campaign_name);
      addSearchFilterToAdvanceFilter(advanceFilter, ["city"], city);
      addSearchFilterToAdvanceFilter(advanceFilter, ["pin_code"], pin_code);
      addSearchFilterToAdvanceFilter(advanceFilter, ["package_name"], package_name);
      addSearchFilterToAdvanceFilter(advanceFilter, ["disposition"], disposition);
      addSearchFilterToAdvanceFilter(advanceFilter, ["primary_disposition"], primary_disposition);
      addSearchFilterToAdvanceFilter(advanceFilter, ["follow_up_date"], follow_up_date);
      // addSearchFilterToAdvanceFilter(advanceFilter, ["membership"], membership);

      let finalUrl = `${endPoints.crossroadsLeads.getCrossroadsLeadsList}?pageNo=${page}&itemPerPage=${rowsPerPage}`;

      if (date && date.fromDate && date.toDate) {
        finalUrl += `&from_date=${date.fromDate}&to_date=${date.toDate}`;
      }


      if (date && date.rangeType) {
        finalUrl += `&rangeType=${date.rangeType}`;
      }

      if (status && status !== "-1") {
        finalUrl += `&status=${status}`;
      }

      if (membership) {
        finalUrl += `&membership=${encodeURIComponent(membership)}`;
      }

      if (advanceFilter.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      }

      const res = await api.get(finalUrl);
      const data = res.data?.data || [];
      const totalRecords = res.data?.totalRecords || 0;

      console.log("Advance Filters", advanceFilter);
      dispatch(fectchCrossroadsLeadsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fectchCrossroadsLeadsListFailure());
      dispatch(showMessage({
        message: err?.response?.data?.message || "Failed to fetch crossroads leads",
        type: "error",
        displayAs: "snackbar",
      }));
    }
  };

/* =========================================================
   SINGLE FETCH ACTIONS
========================================================= */
export const FETCH_CROSSROADS_LEADS_PROGRESS = "FETCH_CROSSROADS_LEADS_PROGRESS";
export const FETCH_CROSSROADS_LEADS_SUCCESS = "FETCH_CROSSROADS_LEADS_SUCCESS";
export const FETCH_CROSSROADS_LEADS_FAILED = "FETCH_CROSSROADS_LEADS_FAILED";

export const fetchCrossroadsLeadsProgress = () => action(FETCH_CROSSROADS_LEADS_PROGRESS);
export const fetchCrossroadsLeadsSuccess = (crossroadsLeads: ICrossroadsLead) => action(FETCH_CROSSROADS_LEADS_SUCCESS, { crossroadsLeads });
export const fetchCrossroadsLeadsFailed = (errorMessage: string) => action(FETCH_CROSSROADS_LEADS_FAILED, { errorMessage });

export const fetchCrossroadsLeadsAsync = (crossroadsLeadsId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchCrossroadsLeadsProgress());
      const res = await api.get(`${endPoints.crossroadsLeads.getCrossroadsLeadsList}?crossroads_lead_uuid=${crossroadsLeadsId}`);
      const data: ICrossroadsLead | undefined = res.data?.data?.[0];
      if (data) {
        dispatch(fetchCrossroadsLeadsSuccess(data));
      } else {
        dispatch(fetchCrossroadsLeadsFailed("No crossroads lead found"));
      }
    } catch (err: any) {
      dispatch(fetchCrossroadsLeadsFailed(err?.response?.data?.message || "Failed to fetch crossroads lead"));
      dispatch(showMessage({
        message: err?.response?.data?.message || "Failed to fetch crossroads lead",
        type: "error",
        displayAs: "snackbar",
      }));
    }
  };

export const upsertCrossRoadsLeadsAsync = (
  crossroadsLeadsData: ICrossroadsLead,
  onCallBack: (isSuccess?: boolean, data?: ICrossroadsLead) => void
): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(openLoaderWithMessage("Saving Crossroads Lead..."));


      const {
        create_ts,
        insert_ts,
        created_by_uuid,
        modified_by_uuid,
        created_by_name,
        modified_by_name,
        crossroads_lead_id,
        crossroads_lead_unique_id,
        rsa_promocode_uuid,
        package_id,
        package_price,
        package_period,
        package_services,
        payment_amount,
        package_period_type,
        ...payload
      } = crossroadsLeadsData;

      console.log("Upsert API payload:", payload);
      const res = await api.post(endPoints.crossroadsLeads.upsertCrossroadsLeads, payload);

      const data: ICrossroadsLead = res.data?.data;
      dispatch(upsertItemInList("crossroadsLeads", data as unknown as Record<string, unknown>));
      dispatch(showMessage({
        message: res.data.message || "Saved successfully",
        type: "success",
        displayAs: "snackbar",
      }));
      onCallBack(true, data);
    } catch (err: any) {
      dispatch(showMessage({
        message: err?.response?.data?.message || "Failed to save lead",
        type: "error",
        displayAs: "snackbar",
      }));
      onCallBack(false);
    } finally {
      dispatch(closeLoaderWithMessage());
    }
  };

export const FETCH_CROSSROADS_LEAD_STATUS_COUNT_PROGRESS = "FETCH_CROSSROADS_LEAD_STATUS_COUNT_PROGRESS";
export const FETCH_CROSSROADS_LEAD_STATUS_COUNT_SUCCESS = "FETCH_CROSSROADS_LEAD_STATUS_COUNT_SUCCESS";
export const FETCH_CROSSROADS_LEAD_STATUS_COUNT_FAILED = "FETCH_CROSSROADS_LEAD_STATUS_COUNT_FAILED";

export const fetchCrossroadsLeadStatusCountProgress = () => action(FETCH_CROSSROADS_LEAD_STATUS_COUNT_PROGRESS);
export const fetchCrossroadsLeadStatusCountSuccess = (data: any[]) =>
  action(FETCH_CROSSROADS_LEAD_STATUS_COUNT_SUCCESS, { data });
export const fetchCrossroadsLeadStatusCountFailed = () => action(FETCH_CROSSROADS_LEAD_STATUS_COUNT_FAILED);

export const fetchCrossroadsLeadStatusCountAsync = (
  date: IDataTableV2DateState["dates"],
  data_wise: string,
  companyOutlet?: string
): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchCrossroadsLeadStatusCountProgress());

      let url = `${endPoints.crossroadsLeads.getCrossroadsStatusLeads}?type=count&from_date=${date.fromDate}&to_date=${date.toDate}&data_wise=${data_wise}`;

      if (companyOutlet) {
        url += `&company_outlet_uuid=${companyOutlet}`;
      }

      const res = await api.get(url);
      const data = res.data.data.statusCounts;

      dispatch(fetchCrossroadsLeadStatusCountSuccess(data || []));
    } catch (err: any) {
      dispatch(fetchCrossroadsLeadStatusCountFailed());
      dispatch(showMessage({
        type: "error",
        message: err.response?.data?.message || "Failed to fetch counts",
        displayAs: "snackbar",
      }));
    }
  };

export const FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_PROGRESS = "FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_PROGRESS";
export const FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_SUCCESS = "FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_SUCCESS";
export const FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_FAILED = "FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_FAILED";

export const fetchCrossroadsLeadsListStatusCountProgress = () => action(FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_PROGRESS);
export const fetchCrossroadsLeadsListStatusCountSuccess = (list: ICrossroadsLead[], totalRecords: number) =>
  action(FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_SUCCESS, { list, totalRecords });
export const fetchCrossroadsLeadsListStatusCountFailed = () => action(FETCH_CROSSROADS_LEADS_LIST_STATUS_COUNT_FAILED);

export const fetchCrossroadsLeadListStatusCountAsync = (
  type: string,
  monthType: string,
  status: string,
  pageNumber: number,
  rowsInPerPage: number,
  limit: number,
  date: IDataTableV2DateState["dates"],
  searchValue: any[],
  company_outlet_uuid?: string
): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchCrossroadsLeadsListStatusCountProgress());

      let urlParams = "";
      if (status && status !== "-1") {
        urlParams += `&status_type=${status}`;
      }
      if (monthType) {
        urlParams += `&data_wise=${monthType}`;
      }
      if (searchValue && searchValue.length > 0) {
        urlParams += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (type) {
        urlParams += `&type=${type}`;
      }
      // if (company_outlet_uuid) {
      //   urlParams += `&company_outlet_uuid=${company_outlet_uuid}`;
      // }


      const finalUrl = `${endPoints.crossroadsLeads.getCrossroadsStatusLeads}?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` + urlParams;

      const res = await api.get(finalUrl);
      const listData: ICrossroadsLead[] = res.data.data.leadList;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchCrossroadsLeadsListStatusCountSuccess(listData, totalRecords));
    } catch (err: any) {
      dispatch(fetchCrossroadsLeadsListStatusCountFailed());
      dispatch(showMessage({
        type: "error",
        message: err.response?.data?.message || "Failed to fetch leads list",
        displayAs: "snackbar",
      }));
    }
  };

/* =========================================================
   FOLLOWUP HISTORY ACTIONS
========================================================= */
export const FETCH_CROSSROADS_FOLLOW_UP_HISTORY_PROGRESS = "FETCH_CROSSROADS_FOLLOW_UP_HISTORY_PROGRESS";
export const FETCH_CROSSROADS_FOLLOW_UP_HISTORY_SUCCESS = "FETCH_CROSSROADS_FOLLOW_UP_HISTORY_SUCCESS";
export const FETCH_CROSSROADS_FOLLOW_UP_HISTORY_FAILED = "FETCH_CROSSROADS_FOLLOW_UP_HISTORY_FAILED";

export const fetchCrossroadsFollowUpHistoryProgress = () => action(FETCH_CROSSROADS_FOLLOW_UP_HISTORY_PROGRESS);
export const fetchCrossroadsFollowUpHistorySuccess = (list: IFollowUpHistory[]) =>
  action(FETCH_CROSSROADS_FOLLOW_UP_HISTORY_SUCCESS, { list });
export const fetchCrossroadsFollowUpHistoryFailed = (errorMessage: string) =>
  action(FETCH_CROSSROADS_FOLLOW_UP_HISTORY_FAILED, { errorMessage });

export const fetchCrossroadsFollowUpHistoryAsync = (
  crossroadsLeadUuid: string
): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchCrossroadsFollowUpHistoryProgress());
      dispatch(saveLoaderProgress());

      // Using the same endpoint pattern as leads, but for crossroads leads
      const res = await api.get(
        `${endPoints.crossroadsLeads.getFollowUpHistory}?crossroads_lead_uuid=${crossroadsLeadUuid}`
      );

      const data: IFollowUpHistory[] = res.data.data || [];
      dispatch(fetchCrossroadsFollowUpHistorySuccess(data));
    } catch (err: any) {
      dispatch(fetchCrossroadsFollowUpHistoryFailed("Failed to fetch follow-up history"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to fetch follow-up history",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/* =========================================================
 FETCH MEMBERSHIPS, INVOICES AND VEHICLES DETAILS FOR CUSTOMER OVERVIEW
========================================================= */
export const FETCH_CROSSROADS_TAB_DATA_PROGRESS = "FETCH_CROSSROADS_TAB_DATA_PROGRESS";
export const FETCH_CROSSROADS_TAB_DATA_SUCCESS = "FETCH_CROSSROADS_TAB_DATA_SUCCESS";
export const FETCH_CROSSROADS_TAB_DATA_FAILURE = "FETCH_CROSSROADS_TAB_DATA_FAILURE";

export const fetchCrossroadsTabDataProgress = (tabType: 'memberships' | 'invoices' | 'vehicles') => action(FETCH_CROSSROADS_TAB_DATA_PROGRESS, { tabType });
export const fetchCrossroadsTabDataSuccess = (data: any[], totalRecords: number, tabType: 'memberships' | 'invoices' | 'vehicles') =>
  action(FETCH_CROSSROADS_TAB_DATA_SUCCESS, { data, totalRecords, tabType });
export const fetchCrossroadsTabDataFailure = (tabType: 'memberships' | 'invoices' | 'vehicles') => action(FETCH_CROSSROADS_TAB_DATA_FAILURE, { tabType });

export const fetchCrossroadsMembershipsInvoicesVehiclesDataAsync = (
  tabType: 'memberships' | 'invoices' | 'vehicles',
  contactNumber: string
): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchCrossroadsTabDataProgress(tabType));

      let endpoint = "";
      if (tabType === 'memberships') {
        endpoint = endPoints.crossroadsLeads.getMemberships;
      }
      if (tabType === 'invoices') {
        endpoint = endPoints.crossroadsLeads.getInvoices;
      }
      if (tabType === 'vehicles') {
        endpoint = endPoints.crossroadsLeads.getVehicleDetails;
      }

      const res = await api.get(`${endpoint}?contact_number=${contactNumber}`);

      let data = res.data?.data;
      if (data && !Array.isArray(data)) {
        data = [data];
      }
      data = data || [];
      const totalRecords = res.data?.totalRecords || data.length;

      dispatch(fetchCrossroadsTabDataSuccess(data, totalRecords, tabType));
    } catch (err: any) {
      dispatch(fetchCrossroadsTabDataFailure(tabType));
      dispatch(showMessage({
        message: err?.response?.data?.message || `Failed to fetch ${tabType}`,
        type: "error",
        displayAs: "snackbar",
      }));
    }
  };

/* =========================================================
   CUSTOMER CONNECTION DETAILS
========================================================= */
export const FETCH_CUSTOMER_CONNECTION_DETAILS_PROGRESS = "FETCH_CUSTOMER_CONNECTION_DETAILS_PROGRESS";
export const FETCH_CUSTOMER_CONNECTION_DETAILS_SUCCESS = "FETCH_CUSTOMER_CONNECTION_DETAILS_SUCCESS";
export const FETCH_CUSTOMER_CONNECTION_DETAILS_FAILED = "FETCH_CUSTOMER_CONNECTION_DETAILS_FAILED";

export const fetchCustomerConnectionDetailsProgress = () => action(FETCH_CUSTOMER_CONNECTION_DETAILS_PROGRESS);
export const fetchCustomerConnectionDetailsSuccess = (list: any[], totalRecords: number) => action(FETCH_CUSTOMER_CONNECTION_DETAILS_SUCCESS, { list, totalRecords });
export const fetchCustomerConnectionDetailsFailed = (errorMessage: string) => action(FETCH_CUSTOMER_CONNECTION_DETAILS_FAILED, { errorMessage });

export const fetchCustomerConnectionDetailsAsync = (
  contactNumber?: string,
  vehicleNumber?: string,
  // membershipCode?: string
): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchCustomerConnectionDetailsProgress());

      let url = `${endPoints.crossroadsLeads.getCustomerConnectionDetails}?`;
      const queryParams = [];
      if (contactNumber) queryParams.push(`contact_number=${contactNumber}`);
      if (vehicleNumber) queryParams.push(`vehicle_number=${vehicleNumber}`);
      // if (membershipCode) queryParams.push(`membership_code=${membershipCode}`);

      url += queryParams.join('&');

      const res = await api.get(url);
      let data = res.data?.data;
      if (data && !Array.isArray(data)) {
        data = [data];
      }
      data = data || [];
      const totalRecords = res.data?.totalRecords || data.length;

      dispatch(fetchCustomerConnectionDetailsSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchCustomerConnectionDetailsFailed(err?.response?.data?.message || "Failed to fetch customer connection details"));
      dispatch(showMessage({
        message: err?.response?.data?.message || "Failed to fetch customer connection details",
        type: "error",
        displayAs: "snackbar",
      }));
    }
  };

/* =========================================================
   CLEAR STATE ACTIONS
========================================================= */
export const CLEAR_CROSSROADS_LEADS_STATE = "CLEAR_CROSSROADS_LEADS_STATE";
export const CLEAR_CROSSROADS_LEADS = "CLEAR_PARTNER_MASTER";
export const CLEAR_CROSSROADS_LEADS_LIST = "CLEAR_CROSSROADS_LEADS_LIST";

export const clearCrossroadsLeadsStste = () => action(CLEAR_CROSSROADS_LEADS_STATE);
export const clearCrossroadsLeads = () => action(CLEAR_CROSSROADS_LEADS);
export const clearCrossroadsLeadsList = () => action(CLEAR_CROSSROADS_LEADS_LIST);